import { LAYOUTS, } from "@voltmoney/types";
import { SupportingDocumentContext, WIDGET, } from "@voltmoney/schema";
import { ACTION } from "./types";
import { getPresignedUrlForAdditionalDocumentToUploadAction, goBack, goBackHeaderAction, goToEmail, navigation, submitForApproval } from "./actions";
import { ROUTE } from '../../routes';
import { getApplicationId, horizontalStepperRepo, maskBankAccountNumber } from "../../configs/utils";
import { api } from "../../configs/api";
import SharedPropsService from "../../SharedPropsService";
import { getAppHeader } from "../../configs/config";
export const template = (height, stepper, supportDocumentType, context, applicationId, accountNumber, currentStepId, headerTitle) => {
    return {
        layout: {
            id: ROUTE.SUPPORTING_DOCUMENT,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: 'supportingDocumentPage', type: WIDGET.SUPPORTING_DOCUMENT_PAGE }
            ]
        },
        datastore: {
            supportingDocumentPage: {
                height: height,
                stepperData: stepper,
                supportDocumentType: supportDocumentType,
                context: context,
                onSelectDocument: {
                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                    type: ACTION.PRESIGN_ACTION,
                    payload: {
                        applicationId: applicationId,
                        currentStepId: currentStepId
                    }
                },
                uploadFile: {
                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                    type: ACTION.SUBMIT_APPROVAL,
                    payload: {
                        applicationId: applicationId,
                        currentStepId: currentStepId
                    }
                },
                accountNumber: accountNumber,
                goBackAction: {
                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                    type: ACTION.GO_BACK,
                    payload: {}
                },
                goBackHeaderAction: {
                    routeId: ROUTE.SUPPORTING_DOCUMENT,
                    type: ACTION.GO_BACK_HEADER,
                    payload: {}
                },
                headerTitle: headerTitle,
                loading: false
            }
        },
    };
};
export const SupportingDocumentMf = {
    onLoad: async (_) => {
        const stepper = await horizontalStepperRepo(_.network);
        const height = _.getHeight();
        const applicationId = await getApplicationId();
        const latestAppilcationDetails = await _.network.get(`${api.borrowerApplication}${applicationId}`, {
            headers: await getAppHeader()
        });
        const currentStepId = latestAppilcationDetails?.data?.currentStepId;
        const getSupportingDocumentInfoForLenderResponse = await _.network.get(`${api.getSupportingDocumentInfoForLender}${applicationId}/${currentStepId}`, {
            headers: await getAppHeader()
        });
        let headerTitle = undefined;
        let context = SupportingDocumentContext.KYC_MISMATCH;
        const accountNumber = maskBankAccountNumber(await SharedPropsService.getAccountNumber());
        switch (currentStepId) {
            case 'KYC_DOCUMENTS':
                headerTitle = 'KYC Verification';
                context = SupportingDocumentContext.KYC_MISMATCH;
                break;
            case 'BANK_ACCOUNT_VERIFICATION':
                headerTitle = 'Link bank account';
                context = SupportingDocumentContext.BANK_MISMATCH;
                break;
            case 'KYC_PHOTO_VERIFICATION':
                headerTitle = 'Photo verification';
                context = SupportingDocumentContext.PHOTO_MISMATCH;
                break;
            case 'DIGIO_MANDATE_SIGN':
                headerTitle = 'Link bank account';
                context = SupportingDocumentContext.BANK_MISMATCH;
                break;
            default:
                context = SupportingDocumentContext.KYC_MISMATCH;
        }
        const supportDocumentType = getSupportingDocumentInfoForLenderResponse?.data;
        return Promise.resolve(template(height, stepper, supportDocumentType, context, applicationId, accountNumber, currentStepId, headerTitle));
    },
    actions: {
        [ACTION.GO_TO_EMAIL]: goToEmail,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.PRESIGN_ACTION]: getPresignedUrlForAdditionalDocumentToUploadAction,
        [ACTION.SUBMIT_APPROVAL]: submitForApproval,
        [ACTION.GO_BACK]: goBack,
        [ACTION.GO_BACK_HEADER]: goBackHeaderAction,
        [ACTION.UPLOAD_FAILED]: goBack
    },
};
